import { IconProp } from "@fortawesome/fontawesome-svg-core";
import classNames from "classnames";
import Icon, {
  SvgIconName,
  ElexonIconName,
} from "components/components/Icon/Icon";
import { IconSize } from "components/components/Icon/IconWrapper";
import React from "react";

import { StyledButton } from "./style";

interface Props {
  children?: JSX.Element;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  ariaLabel?: string;
  ariaDisabled?: boolean;
  buttonText?: string;
  className?: string;
  disabled?: boolean;
  iconName?: IconProp | SvgIconName | ElexonIconName;
  iconColour?: string;
  iconSize?: IconSize;
  textLeftOfIcon?: boolean;
  type?: "submit" | "reset" | "button";
  dataTestId?: string;
}

const Button = React.forwardRef<HTMLButtonElement, Props>(function Button(
  {
    children,
    onClick,
    buttonText,
    className,
    disabled,
    iconName,
    iconColour,
    iconSize,
    textLeftOfIcon,
    ariaLabel,
    ariaDisabled,
    type = "button",
    dataTestId,
  },
  ref
) {
  const textElement = buttonText ? <span>{buttonText}</span> : null;
  const iconElement =
    iconName !== undefined ? (
      <Icon iconName={iconName} colour={iconColour} size={iconSize} />
    ) : null;

  const content = textLeftOfIcon
    ? [textElement, iconElement]
    : [iconElement, textElement];

  return (
    <StyledButton
      onClick={onClick}
      className={classNames("button", className)}
      disabled={disabled}
      aria-label={ariaLabel}
      aria-disabled={ariaDisabled}
      type={type}
      data-test-id={dataTestId}
      ref={ref}
    >
      {content}
      {children}
    </StyledButton>
  );
});

export default Button;
